import { ReactNode } from "react";

import { View } from "./View";

export interface ISwitchAppButtonProps {
  children: ReactNode;
  className?: string;
  kind?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "success"
    | "danger"
    | "warning";
  onClick: () => void;
}

export const SwitchAppButton = (props: ISwitchAppButtonProps) => {
  return <View {...props} />;
};
